<template>
  <section id="renovation-planner" ref="renovation-planner" :class="$style.section">
    <div class="layout-container">
      <StackedCardsRenovationPlanner v-if="isStackedCardsVariant" />
      <TableViewRenovationPlanner v-else />
    </div>
  </section>
</template>

<script setup lang="ts">
import {
  getRenovationPlannerVariantFromQuery,
  isStackedCardsRenovationPlannerVariant,
} from '@/components/my-properties-landing-page/MyPropertiesRenovationPlannerSection/renovationPlannerVariant';
import StackedCardsRenovationPlanner from '@/components/my-properties-landing-page/StackedCardsRenovationPlanner/StackedCardsRenovationPlanner.vue';
import TableViewRenovationPlanner from '@/components/my-properties-landing-page/TableViewRenovationPlanner/TableViewRenovationPlanner.vue';
import { useTrackOnVisible } from '@/composables/useTrackOnVisible';
import { useTrackingWithTreatment } from '@/composables/useTrackingWithTreatment';
import { SplitFeatureFlags } from '@/store/modules/split/splitFeatureFlags';
import { TRACKING_ACTION, TRACKING_LABEL } from '@/tracking/types';
import { computed, onMounted, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const route = useRoute();
const { getTreatmentTrackingParams } = useTrackingWithTreatment();

const renovationPlannerTreatment = computed(
  () => store.getters['split/getTreatment'](SplitFeatureFlags.DD4746_RENOVATION_PLANNER)?.treatment,
);

const renovationPlannerQueryVariant = computed(() =>
  getRenovationPlannerVariantFromQuery(route.query),
);

const isStackedCardsVariant = computed(() =>
  isStackedCardsRenovationPlannerVariant(
    renovationPlannerQueryVariant.value,
    renovationPlannerTreatment.value,
  ),
);

const componentRef = useTemplateRef('renovation-planner');
onMounted(() => {
  if (route.hash === '#renovation-planner') {
    componentRef.value?.scrollIntoView({ behavior: 'smooth' });
  }
});

useTrackOnVisible(
  componentRef,
  TRACKING_ACTION.DISPLAY_HOMEOWNER_TEASER,
  TRACKING_LABEL.RENOVATION_PLANNER_TEASER,
  0.7,
  getTreatmentTrackingParams,
);
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.section {
  padding: $space-100 0;
  background-color: $color-white;
}
</style>
